module.exports = __webpack_public_path__ + "media/svg-new/boss2-1e0958df.svg";